import React, { useEffect, useRef, useState } from "react";
import { startLoader, stopLoader, useAsyncState } from "../../lib/utils";
import { getAllBranches, getBranch, getBranchCount } from "../../features/gyms/helper/api";
import { isAuthenticated } from "../../auth";
import "./style.scss";
import SearchFilter from "../search-filter";
// import config from "../../config";
import client from "../../clients";
import { useQueryParams } from "../../lib/useQueryParams";
import { getProfileByBranches } from "../../core/helper/ProfileApiCall";
import { useHistory } from "react-router-dom";

const GymFilter = (props) => {

  const history = useHistory();
  const {clearAllQueryParam} = useQueryParams();
  var [selectedGym, setSelectedGym] = useState("");
  var [pageCount,setPageCount] = useState(1);
  var [pageNo,setPageNo] = useState(1);
  var pageSize = 14;
  var [total,setTotal] = useState(0);
  const { user, token } = isAuthenticated();
  const [isGymListOpen, setGymListOpen] = useState(false);
  const [isUserRoleListOpen, setUserRoleListOpen] = useState(false);
  const [selectedUserRole, setSelectedUserRole] = useState("")
  const [gymList, setGymList] = useState([]);
  const [gymCurrentPage, setGymCurrentPage] = useAsyncState(1);
  const [isBranchActive, setBranchActive] = useState(true);
  const [searchingData, setSearchingData] = useState("");
  const [isBranchSpinnerLoader,setBranchSpinnerLoader] = useState(false);
  const isInitialLoadComlete = useRef(false);
  const [profiles,setProfiles] = useState([]);
  

  const handleSelectGym = (selectedGym) => {
    setSelectedGym(selectedGym);

    if(!props.isFilterBySlugExistance){
      if(selectedGym?.isBulkChange){
        localStorage.setItem("isBulkChange", true);
      }else{
        localStorage.removeItem("isBulkChange")
      }


      localStorage.setItem("branchId",selectedGym?._id);
      localStorage.setItem("gymId",selectedGym?.gymId);
      window.dispatchEvent(new Event("branchIdChanged"));
    }

    if(props.getSelectedGym){
      props.getSelectedGym(selectedGym);
      clearAllQueryParam();
    }

    setGymListOpen(false);
  }

  const handleSearchingData = (searchingData) => {
    setSearchingData(searchingData);
    // await startLoader();
    // try{
    //   await GetAllBranches();
    // }catch(err){
    //   console.log(err);
    //   await stopLoader();
    // }
    // await stopLoader();
  }

  //API methods
  const getBranchParams = () => {
    let params = {
      pageNo,
      isFilterByProfile:true,
      pageSize:!isInitialLoadComlete.current?1:pageSize
    };
    if(props?.isFilterBySlugExistance) params.isFilterBySlugExistance = true;
    if (searchingData) params.q = searchingData;
    params.activationStatus = isBranchActive ? "active" : "inactive";
    return params;
  }

  const GetAllBranches = async (isReload) => {

    try {
      let param = getBranchParams();

      console.log("USER ID:", user?._id);
      console.log("TOKEN:", token);
      console.log("PARAM:", param);

      console.log("BEFORE getAllBranches");

      const gyms = await getAllBranches(user._id, token, param);


      if(gyms && !gyms?.error){
        if(!isInitialLoadComlete.current) isInitialLoadComlete.current = true;
        setGymList(isReload?gyms:[...gymList,...gyms]);

        const branchId = localStorage.getItem("branchId");
        if (!selectedGym && gyms.length > 0) {
          if (branchId) {
            const alreadySelected = gyms.find(g => g._id === branchId);
            if (alreadySelected) {
              setSelectedGym(alreadySelected);
              if (props.getSelectedGym) props.getSelectedGym(alreadySelected);
            }
          } else {
            setSelectedGym(gyms[0]);
            handleSelectGym(gyms[0])
            if(gyms[0]?.isBulkChange){
              localStorage.setItem("isBulkChange", true);
            }else{
              localStorage.removeItem("isBulkChange")
            }
            localStorage.setItem("branchId", gyms[0]._id);
            localStorage.setItem("gymId", gyms[0].gymId);
            window.dispatchEvent(new Event("branchIdChanged")); 
            if (props.getSelectedGym) props.getSelectedGym(gyms[0]);
          }
        }
      }
    } catch (error) {
    }
  }

  const GetBranchesCount = async () => {
    try {
      let param = getBranchParams();
      delete param.pageNo;
      delete param.pageSize;
      let response = await getBranchCount(user._id, token, param);
      if(!response.error){
        pageNo = 1;
        setPageNo(pageNo)
        pageCount = Math.ceil(response.COUNT / pageSize);
        setPageCount(pageCount)
        total = response.COUNT;
        setTotal(total)
      }
    } catch (error) {
    } 
  }


  const toggleGymList = () => {
    if(props.updateUserListOpen) props.updateUserListOpen(false)
    setGymListOpen(!isGymListOpen);
  }

  const handleBranchScroll = async event => {
    try {
      const { scrollTop, clientHeight, scrollHeight } = event.target;
      if ((scrollTop > 0) && ((Math.ceil((scrollTop + clientHeight)) >= scrollHeight)) && pageNo < pageCount && !isBranchSpinnerLoader) {
        setBranchSpinnerLoader(true)
        pageNo = pageNo + 1;
        setPageNo(pageNo);
        await GetAllBranches();
        setBranchSpinnerLoader(false)
      }
    } catch (error) {
      setBranchSpinnerLoader(false)
    }
  }

  const toggleUserRole = () => {
    setUserRoleListOpen(!isUserRoleListOpen)
  }

  const handleSelectedUserRole = (role) => {
    setSelectedUserRole(role)
  }

  const GetProfileByBranches = async () =>{
    try{
      let response = await getProfileByBranches(user._id,token);

      if(!response.error){
        setGymList(response);
        let find = response.find(d=>d._id == user.branchId && user.role == d.roleNumber);

        console.log(find);

        if(find){
            setSelectedGym(find) 
            if(props?.getSelectedGym) props?.getSelectedGym(find);


            if(find?.featureAccess){
              localStorage.setItem("salesReport", find.featureAccess.salesReport);
            }else{
              localStorage.setItem("salesReport", true);
            }

            if(find?.isBulkChange){
              localStorage.setItem("isBulkChange", true);
            }else{
              localStorage.removeItem("isBulkChange")
            }

            if(find.deletedAt){
              localStorage.setItem("Active", false);
              localStorage.setItem("deletedAt", find.deletedAt);
            }else{
              localStorage.setItem("Active", true);
            }

            localStorage.setItem("branchId", find._id);
            localStorage.setItem("gymId", find.gymId);
            window.dispatchEvent(new Event("branchIdChanged")); 
        }else{
          setSelectedGym(response[0]?response[0]:'')
          if(response?.[0]){
              if(props?.getSelectedGym) props?.getSelectedGym(response?.[0]);
              if(response?.[0]?.isBulkChange){
                localStorage.setItem("isBulkChange", true);
              }else{
                localStorage.removeItem("isBulkChange")
              }
              localStorage.setItem("branchId", response?.[0]?._id);
              localStorage.setItem("gymId", response?.[0]?.gymId);
              try{
                window.dispatchEvent(new Event("branchIdChanged")); 
              }catch(error){}
          }
        }
      }
    }catch(error){
    //  alert(error)
      setBranchSpinnerLoader(false)
    }
  }

  useEffect(async () => {
    if(user.role == 0){
      setBranchSpinnerLoader(true)
      try{
        if(!isInitialLoadComlete.current || (isGymListOpen)){
            await GetAllBranches(true);
            await GetBranchesCount();
        }
      }catch(err){
        console.log(err);
        await stopLoader();
      }
      await stopLoader();
    }
    setBranchSpinnerLoader(false)
  },[searchingData,isGymListOpen]);

  useEffect(()=>{
    if(props.selectedGym && !selectedGym){
      setSelectedGym(props.selectedGym);
    }
  },[props]);

  useEffect(async () => {
    if(props?.isFilterBySlugExistance) return;


    const fetchBranchFromStorage = async () => {
      const branchId = localStorage.getItem("branchId");
      if (branchId) {
        try {
          const response = await getBranch(user._id, token, branchId);
          if (!response.error) {
            setSelectedGym(response);
            if(response?.isBulkChange){
              localStorage.setItem("isBulkChange", true);
            }else{
              localStorage.removeItem("isBulkChange")
            }
            if (props.getSelectedGym) props.getSelectedGym(response);
          } else {
            console.error("Branch fetch error:", response.error);
          }
        } catch (error) {
          console.error("Error fetching branch:", error);
        }
      }
    };


    if(user.role == 0) fetchBranchFromStorage();
    else{
      setBranchSpinnerLoader(true)
      await GetProfileByBranches();
      setBranchSpinnerLoader(false)
    }
  }, [user._id, token]);


  useEffect(async () => {

    const handleClick = () => {
      setGymListOpen(false);
      setUserRoleListOpen(false);
    };
    
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);

  useEffect(() => {
    if(props && props.setSlugSelectedGym && props.setSlugSelectedGym._id){
      setSelectedGym(props.setSlugSelectedGym)
    }
  },[props && props.setSlugSelectedGym && props.setSlugSelectedGym._id])





  return(
    <div className="select-global-gym flex-item d-flex cursor-pointer">
      {
        window.innerWidth < 768 ? (
          <div className="d-flex margin-auto flex-item" onClick={(e)=>e.stopPropagation()}>
            <div onClick={toggleGymList} className="margin-auto">
              <div className="flex-item d-flex">
                <p className="flex-item m-r-4 font-weight-700 color-dark-blue fs-16">{selectedGym && selectedGym.name.length > 0 ? selectedGym.name.length > 12 ?  selectedGym.name.slice(0, 12) + "..." : selectedGym.name : "Select Gym"}</p>
                <svg className="flex-item" style={{transition:"180ms", transform: isGymListOpen ? "rotate(180deg)" : "rotate(0deg)"}} width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.04883 10L12.0488 15L17.0488 10" stroke="#6D6D6D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              {
                user.role == 0 ? 
                <div className="d-flex flex-item">
                  <svg className="flex-item m-r-2" width="12" height="12" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 7.64584C4.5264 7.64584 4.0722 7.45927 3.73731 7.12717C3.40242 6.79508 3.21429 6.34466 3.21429 5.87501C3.21429 5.40535 3.40242 4.95493 3.73731 4.62284C4.0722 4.29074 4.5264 4.10417 5 4.10417C5.4736 4.10417 5.9278 4.29074 6.26269 4.62284C6.59758 4.95493 6.78571 5.40535 6.78571 5.87501C6.78571 6.10755 6.73953 6.33783 6.64979 6.55267C6.56004 6.76752 6.42851 6.96274 6.26269 7.12717C6.09687 7.29161 5.90002 7.42205 5.68336 7.51104C5.46671 7.60004 5.2345 7.64584 5 7.64584ZM5 0.916672C3.67392 0.916672 2.40215 1.43907 1.46447 2.36893C0.526784 3.2988 0 4.55997 0 5.87501C0 9.59376 5 15.0833 5 15.0833C5 15.0833 10 9.59376 10 5.87501C10 4.55997 9.47322 3.2988 8.53553 2.36893C7.59785 1.43907 6.32608 0.916672 5 0.916672Z" fill="#CC0000"/>
                  </svg>
                  <p className="fs-10 flex-item font-weight-400 color-grey-03" style={{lineHeight:"10px"}}>{selectedGym.address}</p>
                </div>:<div className="d-flex flex-item">
                  <svg className="flex-item m-r-2" width="12" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.13045 12.7826H7.91305C7.59018 12.7826 7.28053 12.6543 7.05223 12.426C6.82392 12.1977 6.69566 11.8881 6.69566 11.5652C6.69566 11.2423 6.82392 10.9327 7.05223 10.7044C7.28053 10.4761 7.59018 10.3478 7.91305 10.3478H9.13045V9.13043H7.91305C7.26731 9.13043 6.64801 9.38695 6.1914 9.84356C5.73479 10.3002 5.47827 10.9195 5.47827 11.5652C5.47827 12.211 5.73479 12.8303 6.1914 13.2869C6.64801 13.7435 7.26731 14 7.91305 14H9.13045V12.7826ZM14 11.5652C14 12.211 13.7435 12.8303 13.2869 13.2869C12.8303 13.7435 12.211 14 11.5652 14H10.3478V12.7826H11.5652C11.8881 12.7826 12.1977 12.6543 12.4261 12.426C12.6544 12.1977 12.7826 11.8881 12.7826 11.5652C12.7826 11.2423 12.6544 10.9327 12.4261 10.7044C12.1977 10.4761 11.8881 10.3478 11.5652 10.3478H10.3478V9.13043H11.5652C12.211 9.13043 12.8303 9.38695 13.2869 9.84356C13.7435 10.3002 14 10.9195 14 11.5652Z" fill="#E33A34"/>
                    <path d="M8.52174 10.9566H10.9565V12.174H8.52174V10.9566ZM4.26087 11.5653C4.26209 11.3613 4.28042 11.1577 4.31565 10.9566H1.82609V10.1045C1.82609 8.88708 4.26087 8.21751 5.47826 8.21751C5.75375 8.22121 6.02852 8.24665 6.3 8.2936C6.80105 8.04382 7.35319 7.9136 7.91304 7.91317H10.9565V2.43491C10.9556 2.11233 10.827 1.80324 10.5989 1.57514C10.3708 1.34705 10.0617 1.21848 9.73913 1.21751H7.19478C7.07015 0.861695 6.83801 0.553401 6.5305 0.335282C6.22298 0.117163 5.85528 0 5.47826 0C5.10124 0 4.73354 0.117163 4.42603 0.335282C4.11851 0.553401 3.88638 0.861695 3.76174 1.21751H1.21739C0.894815 1.21848 0.585727 1.34705 0.35763 1.57514C0.129533 1.80324 0.000963399 2.11233 0 2.43491L0 10.9566C0.000963399 11.2792 0.129533 11.5883 0.35763 11.8164C0.585727 12.0445 0.894815 12.1731 1.21739 12.174H4.31565C4.28042 11.973 4.26209 11.7694 4.26087 11.5653ZM5.47826 1.21751C5.59865 1.21751 5.71634 1.25321 5.81643 1.3201C5.91653 1.38698 5.99455 1.48205 6.04062 1.59327C6.08669 1.7045 6.09875 1.82689 6.07526 1.94496C6.05177 2.06304 5.9938 2.1715 5.90867 2.25662C5.82355 2.34175 5.71509 2.39972 5.59701 2.42321C5.47894 2.4467 5.35655 2.43464 5.24532 2.38857C5.1341 2.3425 5.03903 2.26448 4.97215 2.16438C4.90526 2.06428 4.86957 1.9466 4.86957 1.82621C4.87005 1.66492 4.93433 1.51038 5.04838 1.39633C5.16243 1.28228 5.31697 1.218 5.47826 1.21751ZM5.47826 3.6523C5.83943 3.6523 6.19248 3.7594 6.49278 3.96005C6.79308 4.1607 7.02713 4.4459 7.16535 4.77957C7.30356 5.11324 7.33972 5.48041 7.26926 5.83464C7.1988 6.18886 7.02488 6.51424 6.7695 6.76962C6.51412 7.02501 6.18874 7.19892 5.83451 7.26938C5.48029 7.33984 5.11312 7.30368 4.77945 7.16547C4.44577 7.02726 4.16058 6.7932 3.95993 6.4929C3.75927 6.1926 3.65217 5.83955 3.65217 5.47838C3.65185 5.23849 3.69887 5.00089 3.79052 4.77919C3.88218 4.5575 4.01668 4.35606 4.18631 4.18643C4.35594 4.0168 4.55737 3.8823 4.77907 3.79065C5.00076 3.69899 5.23837 3.65198 5.47826 3.6523Z" fill="#E33A34"/>
                  </svg>
                  <p className="fs-10 flex-item font-weight-400 color-grey-03" style={{lineHeight:"10px"}}>{client.config.roleNames[selectedGym.roleName]}</p>
                </div>
              }
            </div>
          </div>
        ) : (
          <div onClick={(e)=>e.stopPropagation()} className="d-flex w-full" >
            {
              !selectedGym ? (
                <div className="w-full d-flex flex-item m-r-20">
                  <p className="flex-item font-weight-700 color-dark-blue fs-16">Select Gym</p>
                </div>
              ) : (
                <div className="w-full d-flex m-r-20">
                 {/* {false && <div onClick={()=>toggleUserRole()} className="flex-item d-flex">
                    <div className="flex-item">
                      <p className="color-red font-weight-600 fs-12" style={{lineHeight:"12px"}}>Role</p>
                      <p className="fs-16 font-weight-600 m-t-6" style={{lineHeight:"16px"}}>{selectedGym?.roleName && config.roleNames[selectedGym.roleName]}</p>
                    </div>
                    <svg className="flex-item m-l-16 m-r-16" width="1" height="32" viewBox="0 0 1 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <line x1="0.5" y1="0.5" x2="0.5" y2="31.5" stroke="#A8A8A8" stroke-linecap="round"/>
                    </svg>
                    {
                      isUserRoleListOpen && (
                        <div className="w-full branch-list-container slideTopToBottom">
                          {
                            roles.filter(d=>d.role != 0).map((role,index)=>{
                              return(
                                <div onClick={()=>handleSelectedUserRole(role.name)} className="branch-list-item d-flex" key={index}>
                                  <p className="flex-item">{config.roleNames[role.name]}</p>
                                </div>
                              ) 
                            }
                           )
                          }
                          <div onClick={()=>handleSelectedUserRole("Branch Admin")} className="branch-list-item d-flex">
                            <p className="flex-item">Branch Admin</p>
                          </div>
                           <div onClick={()=>handleSelectedUserRole("Branch Instructor")} className="branch-list-item d-flex">
                            <p className="flex-item">Branch Instructor</p>
                          </div>
                           <div onClick={()=>handleSelectedUserRole("Member")} className="branch-list-item d-flex">
                            <p className="flex-item">Member</p>
                          </div>
                        </div>
                      )
                    }
                  </div>} */}
                  {/* {console.log(selectedGym)} */}
                  {
                    selectedGym.logoFileID ? (
                      <div className='selected-gym-logo flex-item m-r-8'>
                        <img src={`${client.config.API_URL}/image/file/${selectedGym.logoFileID}/auto/auto/70`} loading='lazy' />
                      </div>
                    ) : (
                      <div className="selected-gym-logo m-r-8 flex-item d-flex" style={{backgroundColor: "#5d883c"}}>
                        <p className='flex-item' style={{color: "#ffffff", margin: "0 auto", fontSize: 14}}>{`${selectedGym.name}`.trim()[0]}</p>
                      </div>
                    ) 
                  }
                  <div onClick={toggleGymList} className="selected-gym-name flex-item">
                    <p className="w-full flex-item m-r-4 font-weight-700 color-dark-blue fs-14">{selectedGym && selectedGym.name.length > 0 ? selectedGym.name.length > 22 ?  selectedGym.name.slice(0, 22) + "..." : selectedGym.name : "NULL"}</p>        
                    {
                      user.role == 0 ?
                      <div className="d-flex m-t-0">
                        <svg className="flex-item m-r-2" width="14" height="14" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5 7.64584C4.5264 7.64584 4.0722 7.45927 3.73731 7.12717C3.40242 6.79508 3.21429 6.34466 3.21429 5.87501C3.21429 5.40535 3.40242 4.95493 3.73731 4.62284C4.0722 4.29074 4.5264 4.10417 5 4.10417C5.4736 4.10417 5.9278 4.29074 6.26269 4.62284C6.59758 4.95493 6.78571 5.40535 6.78571 5.87501C6.78571 6.10755 6.73953 6.33783 6.64979 6.55267C6.56004 6.76752 6.42851 6.96274 6.26269 7.12717C6.09687 7.29161 5.90002 7.42205 5.68336 7.51104C5.46671 7.60004 5.2345 7.64584 5 7.64584ZM5 0.916672C3.67392 0.916672 2.40215 1.43907 1.46447 2.36893C0.526784 3.2988 0 4.55997 0 5.87501C0 9.59376 5 15.0833 5 15.0833C5 15.0833 10 9.59376 10 5.87501C10 4.55997 9.47322 3.2988 8.53553 2.36893C7.59785 1.43907 6.32608 0.916672 5 0.916672Z" fill="#CC0000"/>
                        </svg>
                        <p className="fs-12 flex-item font-weight-400 color-grey-03" style={{lineHeight:"12px"}}>{selectedGym.address && selectedGym.address.length > 30 ? selectedGym.address.slice(0, 30) + "..." : selectedGym.address && selectedGym.address.length < 30 ? selectedGym.address : "--" }</p>
                      </div>:
                      <div className="d-flex m-t-0">
                        <svg className="flex-item m-r-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9.13045 12.7826H7.91305C7.59018 12.7826 7.28053 12.6543 7.05223 12.426C6.82392 12.1977 6.69566 11.8881 6.69566 11.5652C6.69566 11.2423 6.82392 10.9327 7.05223 10.7044C7.28053 10.4761 7.59018 10.3478 7.91305 10.3478H9.13045V9.13043H7.91305C7.26731 9.13043 6.64801 9.38695 6.1914 9.84356C5.73479 10.3002 5.47827 10.9195 5.47827 11.5652C5.47827 12.211 5.73479 12.8303 6.1914 13.2869C6.64801 13.7435 7.26731 14 7.91305 14H9.13045V12.7826ZM14 11.5652C14 12.211 13.7435 12.8303 13.2869 13.2869C12.8303 13.7435 12.211 14 11.5652 14H10.3478V12.7826H11.5652C11.8881 12.7826 12.1977 12.6543 12.4261 12.426C12.6544 12.1977 12.7826 11.8881 12.7826 11.5652C12.7826 11.2423 12.6544 10.9327 12.4261 10.7044C12.1977 10.4761 11.8881 10.3478 11.5652 10.3478H10.3478V9.13043H11.5652C12.211 9.13043 12.8303 9.38695 13.2869 9.84356C13.7435 10.3002 14 10.9195 14 11.5652Z" fill="#E33A34"/>
                          <path d="M8.52174 10.9566H10.9565V12.174H8.52174V10.9566ZM4.26087 11.5653C4.26209 11.3613 4.28042 11.1577 4.31565 10.9566H1.82609V10.1045C1.82609 8.88708 4.26087 8.21751 5.47826 8.21751C5.75375 8.22121 6.02852 8.24665 6.3 8.2936C6.80105 8.04382 7.35319 7.9136 7.91304 7.91317H10.9565V2.43491C10.9556 2.11233 10.827 1.80324 10.5989 1.57514C10.3708 1.34705 10.0617 1.21848 9.73913 1.21751H7.19478C7.07015 0.861695 6.83801 0.553401 6.5305 0.335282C6.22298 0.117163 5.85528 0 5.47826 0C5.10124 0 4.73354 0.117163 4.42603 0.335282C4.11851 0.553401 3.88638 0.861695 3.76174 1.21751H1.21739C0.894815 1.21848 0.585727 1.34705 0.35763 1.57514C0.129533 1.80324 0.000963399 2.11233 0 2.43491L0 10.9566C0.000963399 11.2792 0.129533 11.5883 0.35763 11.8164C0.585727 12.0445 0.894815 12.1731 1.21739 12.174H4.31565C4.28042 11.973 4.26209 11.7694 4.26087 11.5653ZM5.47826 1.21751C5.59865 1.21751 5.71634 1.25321 5.81643 1.3201C5.91653 1.38698 5.99455 1.48205 6.04062 1.59327C6.08669 1.7045 6.09875 1.82689 6.07526 1.94496C6.05177 2.06304 5.9938 2.1715 5.90867 2.25662C5.82355 2.34175 5.71509 2.39972 5.59701 2.42321C5.47894 2.4467 5.35655 2.43464 5.24532 2.38857C5.1341 2.3425 5.03903 2.26448 4.97215 2.16438C4.90526 2.06428 4.86957 1.9466 4.86957 1.82621C4.87005 1.66492 4.93433 1.51038 5.04838 1.39633C5.16243 1.28228 5.31697 1.218 5.47826 1.21751ZM5.47826 3.6523C5.83943 3.6523 6.19248 3.7594 6.49278 3.96005C6.79308 4.1607 7.02713 4.4459 7.16535 4.77957C7.30356 5.11324 7.33972 5.48041 7.26926 5.83464C7.1988 6.18886 7.02488 6.51424 6.7695 6.76962C6.51412 7.02501 6.18874 7.19892 5.83451 7.26938C5.48029 7.33984 5.11312 7.30368 4.77945 7.16547C4.44577 7.02726 4.16058 6.7932 3.95993 6.4929C3.75927 6.1926 3.65217 5.83955 3.65217 5.47838C3.65185 5.23849 3.69887 5.00089 3.79052 4.77919C3.88218 4.5575 4.01668 4.35606 4.18631 4.18643C4.35594 4.0168 4.55737 3.8823 4.77907 3.79065C5.00076 3.69899 5.23837 3.65198 5.47826 3.6523Z" fill="#E33A34"/>
                        </svg>
                        <p className="fs-12 flex-item font-weight-400 color-grey-03" style={{lineHeight:"12px"}}>{client.config.roleNames[selectedGym.roleName]}</p>
                      </div>
                    }
                  </div>
                </div>
              )
            }

            <div onClick={toggleGymList} className="table-action-button d-flex" style={{backgroundColor: isGymListOpen ? "#E33A34" : "var(--darkBlue)", minWidth:"30px", maxWidth:"30px"}}>
              <svg className="flex-item svg-stroke margin-auto" style={{transition:"180ms", transform: isGymListOpen ? "rotate(180deg)" : "rotate(0deg)"}} width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.5 0.5L7 7.5L13.5 0.5" stroke="#ffffff" stroke-linecap="round"/>
              </svg>
            </div>
            
          </div>
        )
      }
     
      {
        isGymListOpen && [
          <div onClick={(e)=>e.stopPropagation()} className="w-full gym-list-container slideTopToBottom">
            {
              window.innerWidth < 768 && (
                <div className="w-full selected-gym-list-container d-flex space-between">
                  {
                    selectedGym ? (
                      <div className="gym-selected-container w-full d-flex">
                        {
                          selectedGym.logoFileID ? (
                            <div className='selected-gym-logo flex-item m-r-8'>
                              <img src={`${client.config.API_URL}/image/file/${selectedGym.logoFileID}/auto/auto/70`} loading='lazy' />
                            </div>
                          ) : (
                            <div className="selected-gym-logo m-r-8 flex-item d-flex" style={{backgroundColor: "#5d883c"}}>
                              <p className='flex-item' style={{color: "#ffffff", margin: "0 auto", fontSize: 14}}>{`${selectedGym.name}`.trim()[0]}</p>
                            </div>
                          ) 
                        }
                        <div className="selected-gym-name flex-item">
                          <p className="w-full flex-item m-r-4 font-weight-700 color-dark-blue fs-16">{selectedGym && selectedGym.name.length > 0 ? selectedGym.name.length > 22 ?  selectedGym.name.slice(0, 22) + "..." : selectedGym.name : "NULL"}</p>        
                         {user.role == 0 ? <div className="d-flex m-t-4">
                            <svg className="flex-item m-r-2" width="14" height="14" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M5 7.64584C4.5264 7.64584 4.0722 7.45927 3.73731 7.12717C3.40242 6.79508 3.21429 6.34466 3.21429 5.87501C3.21429 5.40535 3.40242 4.95493 3.73731 4.62284C4.0722 4.29074 4.5264 4.10417 5 4.10417C5.4736 4.10417 5.9278 4.29074 6.26269 4.62284C6.59758 4.95493 6.78571 5.40535 6.78571 5.87501C6.78571 6.10755 6.73953 6.33783 6.64979 6.55267C6.56004 6.76752 6.42851 6.96274 6.26269 7.12717C6.09687 7.29161 5.90002 7.42205 5.68336 7.51104C5.46671 7.60004 5.2345 7.64584 5 7.64584ZM5 0.916672C3.67392 0.916672 2.40215 1.43907 1.46447 2.36893C0.526784 3.2988 0 4.55997 0 5.87501C0 9.59376 5 15.0833 5 15.0833C5 15.0833 10 9.59376 10 5.87501C10 4.55997 9.47322 3.2988 8.53553 2.36893C7.59785 1.43907 6.32608 0.916672 5 0.916672Z" fill="#CC0000"/>
                            </svg>
                            <p className="fs-12 flex-item font-weight-400 color-grey-03" style={{lineHeight:"12px"}}>{selectedGym.address}</p>
                          </div>:<div className="d-flex m-t-4">
                            <svg className="flex-item m-r-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.13045 12.7826H7.91305C7.59018 12.7826 7.28053 12.6543 7.05223 12.426C6.82392 12.1977 6.69566 11.8881 6.69566 11.5652C6.69566 11.2423 6.82392 10.9327 7.05223 10.7044C7.28053 10.4761 7.59018 10.3478 7.91305 10.3478H9.13045V9.13043H7.91305C7.26731 9.13043 6.64801 9.38695 6.1914 9.84356C5.73479 10.3002 5.47827 10.9195 5.47827 11.5652C5.47827 12.211 5.73479 12.8303 6.1914 13.2869C6.64801 13.7435 7.26731 14 7.91305 14H9.13045V12.7826ZM14 11.5652C14 12.211 13.7435 12.8303 13.2869 13.2869C12.8303 13.7435 12.211 14 11.5652 14H10.3478V12.7826H11.5652C11.8881 12.7826 12.1977 12.6543 12.4261 12.426C12.6544 12.1977 12.7826 11.8881 12.7826 11.5652C12.7826 11.2423 12.6544 10.9327 12.4261 10.7044C12.1977 10.4761 11.8881 10.3478 11.5652 10.3478H10.3478V9.13043H11.5652C12.211 9.13043 12.8303 9.38695 13.2869 9.84356C13.7435 10.3002 14 10.9195 14 11.5652Z" fill="#E33A34"/>
<path d="M8.52174 10.9566H10.9565V12.174H8.52174V10.9566ZM4.26087 11.5653C4.26209 11.3613 4.28042 11.1577 4.31565 10.9566H1.82609V10.1045C1.82609 8.88708 4.26087 8.21751 5.47826 8.21751C5.75375 8.22121 6.02852 8.24665 6.3 8.2936C6.80105 8.04382 7.35319 7.9136 7.91304 7.91317H10.9565V2.43491C10.9556 2.11233 10.827 1.80324 10.5989 1.57514C10.3708 1.34705 10.0617 1.21848 9.73913 1.21751H7.19478C7.07015 0.861695 6.83801 0.553401 6.5305 0.335282C6.22298 0.117163 5.85528 0 5.47826 0C5.10124 0 4.73354 0.117163 4.42603 0.335282C4.11851 0.553401 3.88638 0.861695 3.76174 1.21751H1.21739C0.894815 1.21848 0.585727 1.34705 0.35763 1.57514C0.129533 1.80324 0.000963399 2.11233 0 2.43491L0 10.9566C0.000963399 11.2792 0.129533 11.5883 0.35763 11.8164C0.585727 12.0445 0.894815 12.1731 1.21739 12.174H4.31565C4.28042 11.973 4.26209 11.7694 4.26087 11.5653ZM5.47826 1.21751C5.59865 1.21751 5.71634 1.25321 5.81643 1.3201C5.91653 1.38698 5.99455 1.48205 6.04062 1.59327C6.08669 1.7045 6.09875 1.82689 6.07526 1.94496C6.05177 2.06304 5.9938 2.1715 5.90867 2.25662C5.82355 2.34175 5.71509 2.39972 5.59701 2.42321C5.47894 2.4467 5.35655 2.43464 5.24532 2.38857C5.1341 2.3425 5.03903 2.26448 4.97215 2.16438C4.90526 2.06428 4.86957 1.9466 4.86957 1.82621C4.87005 1.66492 4.93433 1.51038 5.04838 1.39633C5.16243 1.28228 5.31697 1.218 5.47826 1.21751ZM5.47826 3.6523C5.83943 3.6523 6.19248 3.7594 6.49278 3.96005C6.79308 4.1607 7.02713 4.4459 7.16535 4.77957C7.30356 5.11324 7.33972 5.48041 7.26926 5.83464C7.1988 6.18886 7.02488 6.51424 6.7695 6.76962C6.51412 7.02501 6.18874 7.19892 5.83451 7.26938C5.48029 7.33984 5.11312 7.30368 4.77945 7.16547C4.44577 7.02726 4.16058 6.7932 3.95993 6.4929C3.75927 6.1926 3.65217 5.83955 3.65217 5.47838C3.65185 5.23849 3.69887 5.00089 3.79052 4.77919C3.88218 4.5575 4.01668 4.35606 4.18631 4.18643C4.35594 4.0168 4.55737 3.8823 4.77907 3.79065C5.00076 3.69899 5.23837 3.65198 5.47826 3.6523Z" fill="#E33A34"/>
</svg>
                            <p className="fs-12 flex-item font-weight-400 color-grey-03" style={{lineHeight:"12px"}}>{client.config.roleNames[selectedGym.roleName]}</p>
                          </div>}
                        </div>
                      </div>
                    ) : (
                      <p className="selected-gym-name flex-item m-r-4 font-weight-700 color-dark-blue fs-20">Select Gym</p>        
                    )
                  }
                  <div onClick={toggleGymList} className="table-action-button d-flex" style={{backgroundColor: isGymListOpen ? "#E33A34" : "#ffffff"}}>
                    <svg className="flex-item svg-stroke margin-auto" style={{transition:"180ms", transform: isGymListOpen ? "rotate(180deg)" : "rotate(0deg)"}} width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0.5 0.5L7 7.5L13.5 0.5" stroke={isGymListOpen ? "#ffffff" : "#9A9A9A"} stroke-linecap="round"/>
                    </svg>
                  </div>
                </div>
              )
            }
           {user.role == 0 && <div className={`w-full ${window.innerWidth > 767 && "p-t-12 p-l-12 p-r-12"}`}>
              <SearchFilter count={total} isFilterDropdown={true} searchType={"Gym"} filterSection="gym-filter"  isSearchEnabled={true} searchingData={handleSearchingData} isFilterEnabled={false} searchFieldWidth={window.innerWidth > 767 ? 240 : ""}/>
            </div>}
            <div className={`gym-list ${window.innerWidth > 767 && "m-t-16"}`} style={{height: (window.innerWidth < 768 && selectedGym != null)  ? "75%" : "",maxHeight:window.innerWidth < 768?390:""}} onScroll={user.role==0 && handleBranchScroll}>
              
              {
                gymList.map(data => {
                  return(
                    <div onClick={()=>user.role!=0?history.push('/setup?profile='+data.profileId+"&switch="+data.roleNumber):handleSelectGym(data)} className="d-flex cursor-pointer gyms-list-item">
                      {
                        data.logoFileID ? (
                          <div className='gym-list-logo flex-item m-r-12'>
                            <img id="gym-ImgWrapper" src={`${client.config.API_URL}/image/file/${data.logoFileID}/auto/auto/70`} loading='lazy' />
                          </div>
                        ) : (
                          <div className="gym-list-logo m-r-12 flex-item d-flex" style={{backgroundColor: "#5d883c"}}>
                            <p className='flex-item' style={{color: "#ffffff", margin: "0 auto", fontSize: 14}}>{`${data.name}`.trim()[0]}</p>
                          </div>
                        ) 
                      }
                      <div className="flex-item">
                        <p className="font-weight-700 color-dark-blue" style={{lineHeight:"16px"}}>{data.name}</p>
                        <div className="d-flex m-t-4">
                         {!data.roleName ? <svg className="flex-item m-r-2" width="14" height="14" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 7.64584C4.5264 7.64584 4.0722 7.45927 3.73731 7.12717C3.40242 6.79508 3.21429 6.34466 3.21429 5.87501C3.21429 5.40535 3.40242 4.95493 3.73731 4.62284C4.0722 4.29074 4.5264 4.10417 5 4.10417C5.4736 4.10417 5.9278 4.29074 6.26269 4.62284C6.59758 4.95493 6.78571 5.40535 6.78571 5.87501C6.78571 6.10755 6.73953 6.33783 6.64979 6.55267C6.56004 6.76752 6.42851 6.96274 6.26269 7.12717C6.09687 7.29161 5.90002 7.42205 5.68336 7.51104C5.46671 7.60004 5.2345 7.64584 5 7.64584ZM5 0.916672C3.67392 0.916672 2.40215 1.43907 1.46447 2.36893C0.526784 3.2988 0 4.55997 0 5.87501C0 9.59376 5 15.0833 5 15.0833C5 15.0833 10 9.59376 10 5.87501C10 4.55997 9.47322 3.2988 8.53553 2.36893C7.59785 1.43907 6.32608 0.916672 5 0.916672Z" fill="#CC0000"/>
                          </svg>:<svg className="flex-item m-r-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.13045 12.7826H7.91305C7.59018 12.7826 7.28053 12.6543 7.05223 12.426C6.82392 12.1977 6.69566 11.8881 6.69566 11.5652C6.69566 11.2423 6.82392 10.9327 7.05223 10.7044C7.28053 10.4761 7.59018 10.3478 7.91305 10.3478H9.13045V9.13043H7.91305C7.26731 9.13043 6.64801 9.38695 6.1914 9.84356C5.73479 10.3002 5.47827 10.9195 5.47827 11.5652C5.47827 12.211 5.73479 12.8303 6.1914 13.2869C6.64801 13.7435 7.26731 14 7.91305 14H9.13045V12.7826ZM14 11.5652C14 12.211 13.7435 12.8303 13.2869 13.2869C12.8303 13.7435 12.211 14 11.5652 14H10.3478V12.7826H11.5652C11.8881 12.7826 12.1977 12.6543 12.4261 12.426C12.6544 12.1977 12.7826 11.8881 12.7826 11.5652C12.7826 11.2423 12.6544 10.9327 12.4261 10.7044C12.1977 10.4761 11.8881 10.3478 11.5652 10.3478H10.3478V9.13043H11.5652C12.211 9.13043 12.8303 9.38695 13.2869 9.84356C13.7435 10.3002 14 10.9195 14 11.5652Z" fill="#E33A34"/>
                            <path d="M8.52174 10.9566H10.9565V12.174H8.52174V10.9566ZM4.26087 11.5653C4.26209 11.3613 4.28042 11.1577 4.31565 10.9566H1.82609V10.1045C1.82609 8.88708 4.26087 8.21751 5.47826 8.21751C5.75375 8.22121 6.02852 8.24665 6.3 8.2936C6.80105 8.04382 7.35319 7.9136 7.91304 7.91317H10.9565V2.43491C10.9556 2.11233 10.827 1.80324 10.5989 1.57514C10.3708 1.34705 10.0617 1.21848 9.73913 1.21751H7.19478C7.07015 0.861695 6.83801 0.553401 6.5305 0.335282C6.22298 0.117163 5.85528 0 5.47826 0C5.10124 0 4.73354 0.117163 4.42603 0.335282C4.11851 0.553401 3.88638 0.861695 3.76174 1.21751H1.21739C0.894815 1.21848 0.585727 1.34705 0.35763 1.57514C0.129533 1.80324 0.000963399 2.11233 0 2.43491L0 10.9566C0.000963399 11.2792 0.129533 11.5883 0.35763 11.8164C0.585727 12.0445 0.894815 12.1731 1.21739 12.174H4.31565C4.28042 11.973 4.26209 11.7694 4.26087 11.5653ZM5.47826 1.21751C5.59865 1.21751 5.71634 1.25321 5.81643 1.3201C5.91653 1.38698 5.99455 1.48205 6.04062 1.59327C6.08669 1.7045 6.09875 1.82689 6.07526 1.94496C6.05177 2.06304 5.9938 2.1715 5.90867 2.25662C5.82355 2.34175 5.71509 2.39972 5.59701 2.42321C5.47894 2.4467 5.35655 2.43464 5.24532 2.38857C5.1341 2.3425 5.03903 2.26448 4.97215 2.16438C4.90526 2.06428 4.86957 1.9466 4.86957 1.82621C4.87005 1.66492 4.93433 1.51038 5.04838 1.39633C5.16243 1.28228 5.31697 1.218 5.47826 1.21751ZM5.47826 3.6523C5.83943 3.6523 6.19248 3.7594 6.49278 3.96005C6.79308 4.1607 7.02713 4.4459 7.16535 4.77957C7.30356 5.11324 7.33972 5.48041 7.26926 5.83464C7.1988 6.18886 7.02488 6.51424 6.7695 6.76962C6.51412 7.02501 6.18874 7.19892 5.83451 7.26938C5.48029 7.33984 5.11312 7.30368 4.77945 7.16547C4.44577 7.02726 4.16058 6.7932 3.95993 6.4929C3.75927 6.1926 3.65217 5.83955 3.65217 5.47838C3.65185 5.23849 3.69887 5.00089 3.79052 4.77919C3.88218 4.5575 4.01668 4.35606 4.18631 4.18643C4.35594 4.0168 4.55737 3.8823 4.77907 3.79065C5.00076 3.69899 5.23837 3.65198 5.47826 3.6523Z" fill="#E33A34"/>
                            </svg>}
                          <p className="fs-12 flex-item font-weight-400 color-grey-03" style={{lineHeight:"12px"}}>{data.roleName?client.config.roleNames[data.roleName]:data.address && data.address.length > 50 ? data.address.slice(0, 50) + "..." : data.address && data.address.length < 50 ? data.address : "--" }</p>
                        </div>
                      </div>
                    </div>
                  )
                })
              }
             {isBranchSpinnerLoader && <div className="loader-5 center"><span></span></div>}
            </div>
          </div>,
          window.innerWidth < 768 && (
            <div onClick={toggleGymList} className="modal-bg-blur" style={{zIndex: 8}}/>
          )
        ]
      }
    </div>
  )
}

export default GymFilter;